// ======================================================================</editor-fold>
// VARIABLES
// ======================================================================<editor-fold>
const tooltips = {
    'total': 'Total',
    'co2': 'CO2 Emissions',
    'energy': 'Energy Consumption',
    'air-quality': 'Air Quality',
    'recycling': 'Recycling',
    'fly-tipping': 'Fly Tipping',
    'litter': 'Litter',
    'green-space': 'Green Space and Parks',
    'nature-reserves': 'Nature Reserves',
    'car-charging': 'Electric Car Charging Points',
    'traffic-congestion': 'Traffic Congestion'
};
const overrideTableOptions = {
    target: 'table',
    sortProp: 'total',
    displayLimit: 10,
    assignRowTo: 'city',
    include: {
        auxiliaryCols: ['city', 'rank'],
        data: ['rank', 'city', 'total', 'co2', 'energy', 'air quality', 'recycling', 'fly tipping', 'litter', 'green space', 'nature reserves', 'car charging', 'traffic congestion'],
        header: {
            'rank': '#',
            'city': 'City',
            'total': new Element({
                element: 'div', classes: 'table__col-img'
            }).returnElement(),
            'co2': new Element({
                element: 'div', classes: 'table__col-img'
            }).returnElement(),
            'energy': new Element({
                element: 'div', classes: 'table__col-img'
            }).returnElement(),
            'air quality': new Element({
                element: 'div', classes: 'table__col-img'
            }).returnElement(),
            'recycling': new Element({
                element: 'div', classes: 'table__col-img'
            }).returnElement(),
            'fly tipping': new Element({
                element: 'div', classes: 'table__col-img'
            }).returnElement(),
            'litter': new Element({
                element: 'div', classes: 'table__col-img'
            }).returnElement(),
            'green space': new Element({
                element: 'div', classes: 'table__col-img'
            }).returnElement(),
            'nature reserves': new Element({
                element: 'div', classes: 'table__col-img'
            }).returnElement(),
            'car charging': new Element({
                element: 'div', classes: 'table__col-img'
            }).returnElement(),
            'traffic congestion': new Element({
                element: 'div', classes: 'table__col-img'
            }).returnElement()
        },
        mobileControl: {
            titles: {
                'total': 'Total',
                'co2': 'CO2 Emissions',
                'energy': 'Energy Consumption',
                'air quality': 'Air Quality',
                'recycling': 'Recycling',
                'fly tipping': 'Fly Tipping',
                'litter': 'Litter',
                'green space': 'Green Space and Parks',
                'nature reserves': 'Nature Reserves',
                'car charging': 'Electric Car Charging Points',
                'traffic congestion': 'Traffic Congestion'
            },
            listControlBtn: {
                text: 'dynamic',
            }
        },
        toggleRowBtns: {
            showText: 'View More',
            hideText: 'View Less',
            limitReveal: 2
        }
    }

};

// ======================================================================</editor-fold>
// FUNCTIONS
// ======================================================================<editor-fold>
function setupTooltips()
{
    for (const item in tooltips)
    {
        tippy(`.table__row--header .table__col--${item} .table__col-img`, {
            content: tooltips[item],
            // offset: [0, 10],
        });
    }
}

// ======================================================================</editor-fold>
// EVENTS
// ======================================================================<editor-fold>
// ************************************</editor-fold>
// TABLE
// ************************************<editor-fold>
const table = new Table({data: data, rankHighToLow: true, empty_value: '-'}, overrideTableOptions);

new EventDelegator({
    delegators: [{
        selector: '#js-app',
        eventType: 'click',
        events: {
            scrollintoview: (e, dataset) =>
            {
                smooth_scroll({target: `#${dataset.scrollintoview}`});
            },
            scrolltotop: (e, dataset) =>
            {
                smooth_scroll({backToTop: true, duration: 0})
            }
        }
    }]
});

// ************************************</editor-fold>
// TOGGLE
// ************************************<editor-fold>
new Toggle();
// ************************************</editor-fold>
// TOOLTIPS
// ************************************<editor-fold>
setupTooltips();
// ************************************</editor-fold>
// SOCIAL
// ************************************<editor-fold>
new GenerateSocialLinks();


